var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.unreadNotifications.length > 0)?_c('div',_vm._l((_vm.unreadNotifications),function(notification){return _c('system-alert',{key:notification.id,attrs:{"notification":notification},on:{"dismiss":function($event){return _vm.dismiss(notification)}}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }